import { WContainer } from '@components/atoms'
import { SimpleCard } from '@components/molecules'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import styles from './CardGrid.module.sass'
import GenericSection from '../GenericSection/GenericSection'

interface Props {
  className?: string
  item: MenuItemType
  theme?: GenericSectionThemeType
}

const CardGrid = (props: Props) => {
  const { item, theme = 'white', className = '' } = props

  return item.children?.length ? (
    <GenericSection item={item} theme={theme} className={`${styles.root} ${className}`}>
      <div className={styles.list}>
        {item.children.map((item) => (
          <SimpleCard key={item.pk} item={item} size="md" mobileSize="sm" />
        ))}
      </div>
    </GenericSection>
  ) : (
    <></>
  )
}

export default CardGrid
